import { render, staticRenderFns } from "./ModalSuscripcion.vue?vue&type=template&id=524c9feb"
import script from "./ModalSuscripcion.vue?vue&type=script&lang=js"
export * from "./ModalSuscripcion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports